// import { useEffect } from 'react'
import Image from 'components/image/image'
// import Meta from 'components/meta/meta'
// import useAppState from 'utils/state'
import styles from 'styles/page/parduotuve.module.scss'
// import { getData } from 'utils/api'
// import { trackViewAccount } from 'utils/analytics/events'
// import ProductsAccount from 'components/hits/products-account'
import Heading from 'components/heading/heading'
import Rating from 'components/rating/rating'
import addKeywords from 'utils/keywords'
import FeatureIcons from 'components/feature-icons/feature-icons'
import { cn } from 'utils/helpers'

export default function AccountProfile2({ account, setTab }) {
    return (
        <>
            {account.cover_image && (
                <div className={styles.hero}>
                    <div className={styles.cover}>
                        <Image
                            src={account.cover_image}
                            alt={account.name}
                            priority={true}
                            layout="fill"
                            objectFit="cover"
                        />
                    </div>
                </div>
            )}
            <div className={styles.topSection}>
                <div className={styles.logo}>
                    <div className={styles.logoCenter}>
                        <Image
                            src={account.image ? account.image : '/img/default-logo.png'}
                            alt={account.name}
                            layout="responsive"
                            objectFit="contain"
                            width="180"
                            height="180"
                        />
                    </div>
                </div>
                <div className={styles.heroName}>
                    <Heading size="30" tag="h1">
                        {account.name}
                    </Heading>
                    <div className={styles.faded}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: addKeywords(account.short_description)
                            }}
                        />
                        {account.show_free_shipping_from && (
                            <div>
                                Nemokamas pristatymas nuo <b>{account.show_free_shipping_from}€</b>
                            </div>
                        )}
                        <div
                            className={styles.contact}
                            dangerouslySetInnerHTML={{
                                __html: account.contacts
                            }}
                        />
                    </div>
                    {!!account.review_count && (
                        <Rating rating={Math.ceil(account.review_rating)} count={account.review_count} />
                    )}
                </div>
                {((account.features && account.features.length) || account.excerpt) && (
                    <div className={cn(styles.right, !account.features.length && styles.nofeatures)}>
                        <div className={styles.featuresBlock}>
                            <FeatureIcons features={account.features} />
                        </div>
                        <div className={styles.rightText}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: addKeywords(account.excerpt, [account.short_description])
                                }}
                            />{' '}
                            {account.excerpt.slice(account.excerpt.length - 3) === '...' && (
                                <span onClick={() => setTab(1)} className={styles.more}>
                                    Daugiau
                                </span>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
